import * as tw from 'rev.sdk.js/Locale/tw';

const labels = {
  ...tw.labels,
  intro: '介紹',
  spec: '規格',
  remark: '備註',
  share_link: '複製分享連結',
  confirm: '確認',
  customer_support: '聯絡我們',
  customer_support_title: '問題類型',
  customer_support_content: '詢問內容',
  name: '姓名',
  phone: '聯絡電話',
  email: '信箱',
  updated: '更新時間',
  next_article: '上一篇',
  prev_article: '下一篇',
  cart: '購物車',
  cart_add: '加入購物車',
  cart_add_error_message_items_limit: '超過購物車購買上限，請分批購買',
  cart_add_error_message: '發生錯誤, 請至個人頁面按下「清除購物車」再重新嘗試',
  cart_clear: '清除購物車',
  cart_clear_success: '清除購物車成功',
  cart_clear_failure: '清除購物車失敗，請與客服人員聯繫',
  cart_empty_content: '購物車尚無商品！歡迎選購加入購物車！',
  buy_now: '立即購買',
  checkout_info: '寄送資訊',
  cart_empty: 'Cart Empty',
  sale_start_time: '供應開始時間',
  sale_end_time: '供應結束時間',
  consult: '立即諮詢',
  line_taipei: '台北line@',
  line_taichung: '台中line@',
  messenger_taipei: '台北 messenger',
  messenger_taichung: '台中 messenger',
  //landing
  landing: '首頁',
  latest_news: '最新消息',
  see_more: '查看更多',
  about: '關於我們',
  about_description: `微媞時尚診所以優質完善的醫療技術與美學品味，打造眾多成功案例。專屬客製化諮詢服務，讓每位顧客都能在輕鬆且專業的諮詢對談中，體認到不同以往的自我價值。協助客戶實現心中的美麗嚮往是我們的使命，而平實價格也讓美麗輕鬆實現。\n\n2011年台北院成立\n2013年起完成ISO專業品質管理系統認證\n2014年入選FG百大醫美\n2014年台中院成立`,
  witness: '美麗見證',
  //about
  core_value: '品牌核心',
  core_value_subtitle:
    '美麗的最高境界\n是讓內在心靈及外觀樣貌，同時達到最美的平衡狀態',
  core_value_description: `醫美不再只是治療，而是一種探尋自我的體驗\n\n微媞期待在這段體驗的過程中\n成為你的美麗導師，也成為你的美麗閨蜜\n幫助您實現對美的嚮往，也陪著你探索自信\n\n由內而外，不論是內心或外表\n都呈現出最美的樣貌，成為更好的自己。`,
  clinic_taipei: '微媞時尚診所 台北院',
  clinic_taipei_description:
    '微媞時尚集團於2011年成立–台北微媞時尚診所，從膚質管理、老化容貌改善、五官立體調整，到身形曲線雕塑等，運用全方位的專業美感規劃，客製化的專屬服務及平實的價格，讓每位客戶都能獲得超值有感的美學體驗。為客戶找回自信是我們始終如一的目標。選擇微媞，美麗不再遙遠。',
  clinic_taipei_contact:
    '服務專線 (02) 2721-9663\n診所位置 106台北市大安區忠孝東路四段250號2樓\n台北院營業時間：週一三五六 11:00~20:00 / 週二四 12:00~21:00',
  clinic_taichung: '微媞時尚診所 台中院',
  clinic_taichung_description:
    '「青春美麗」是人們對於美的永恆需求，為擴大品牌價值，滿足更多美的需要，微媞時尚集團於2014年成立–台中微媞時尚診所。延續品牌理念，以精緻親切的客戶服務為訴求，提供客戶全方位的醫美服務與完善醫療品質，讓美麗不斷延續。',
  clinic_taichung_contact:
    '服務專線 (04)2328-8880\n診所位置 408台中市南屯區向上路一段658號3樓\n台中院營業時間：週一至週五 11:00~20:00 / 週六10:00~19:00',
  charity: '公益活動',
  //article
  announcement: '院內公告',
  hotnews: '熱門消息',
  cosmetic: '醫美專欄',
  video: '影音專區',
  //member list
  team: '醫生團隊',
  team_description:
    '專業技術精準展現，實現專屬質感美\n專業醫師團隊用豐富的美學經驗，權威認證技術與細心的服務態度，共同量身打造專屬於你的美麗與自信。',
  //service
  service: '服務項目',
  beauty_care: '美容保養',
  beauty_care_description:
    '透過醫學美容專業護膚課程，達到內外兼具的美麗。\n改善：青春痘，粉刺，膚況不穩，體內代謝，乾燥暗沉等肌膚問題',
  beauty_injection: '微整注射',
  beauty_injection_description:
    '透過填充劑注射的方式，修飾臉型五官，提升臉部精緻度及立體度。\n改善：臉型線條及飽滿度修飾，動態紋路，靜態紋路，五官立體度',
  beauty_lifting: '拉提美學',
  beauty_lifting_description:
    '透過埋線，電音波等課程，對抗地心引力，喚回肌齡，重現年輕緊緻。\n改善：輪廓線模糊，膚質鬆垮，老化下垂',
  laser: '雷射光療',
  laser_description:
    '透過不同波長的「光」達到膚質改善及美容保養的效果。\n改善：毛孔粗大，斑點色素痘疤，膚色不均，凹洞疤痕，除毛',
  acne_scar_treatment: '凹疤／痘疤治療',
  female_private: '女性私密',
  female_private_description:
    '女人最珍貴的私密肌膚，需要從裡到外的用心呵護，恢復自在清爽\n改善：老化乾澀，產後鬆弛漏尿，反覆感染發炎，私密處暗沉 ',
  plastic_surgery: '整形手術',
  plastic_surgery_description:
    '透過外科手術針對個人眼型條件及需求改變外觀，眼睛有神更帶電\n改善：內雙，單眼皮，大小眼，眼袋，淚溝',
  //witness
  witness_description:
    '美麗 是自信的開始，微媞將實現你的美麗嚮往\n發佈內容已由當事人同意作為醫療資訊分享使用，治療效果因人而異，實際狀況須由專業醫師審慎評估後而定。',
  //contact
  contact: '預約諮詢',
  contact_description:
    '歡迎透過表單或點擊右下方加入官方LINE留言諮詢，我們會盡快與您聯繫。',
  faq: '常見問答',
  faq_description:
    '若對於服務項目有其他需求及疑問，歡迎透過線上客服或填寫意見表單與我們聯繫，我們會盡快為您服務。',
  follow_us: '加入我們',
  follow_us_description:
    '歡迎追蹤微媞時尚診所相關官方社群，持續關注微媞最新動態，與美麗更靠近。',
  clinic_taipei_line: '台北院\nLine生活圈',
  clinic_taipei_messenger: '台北院\nMessenger',
  clinic_taipei_wechat: '台北院\nWechat微信',
  clinic_taichung_line: '台中院\nLine生活圈',
  clinic_taichung_messenger: '台中院\nMessenger',
  clinic_taichung_wechat: '台中院\nWechat微信',
  mail_name: '您的姓名',
  mail_name_warning: '請輸入您的姓名',
  mail_gender: '先生/女士',
  mail_gender_warning: '請選擇您的性別',
  mail_gender_male: '先生',
  mail_gender_female: '女士',
  mail_gender_other: '其他',
  mail_clinic: '聯繫院所',
  mail_clinic_warning: '請輸入聯繫院所',
  mail_clinic_taipei: '台北院',
  mail_clinic_taichung: '台中院',
  mail_contact_time: '方便聯繫時段',
  mail_contact_time_warning: '請輸入您方便的聯繫時段',
  mail_contact_content: '詢問內容',
  mail_contact_content_warning: '請輸入您想詢問的內容',
  mail_agreement_warning: '請先閱讀及勾選同意',
  mail_agreement_law_prefix: '我已確實閱讀',
  mail_agreement_law: '個資法說明',
  mail_agreement_law_addon: '內容，勾選同意方可送出表單。',
  mail_confirm: '確認送出',
  mail_contact_type: '選擇聯繫方式',
  mail_contact_type_warning: '請選擇聯絡方式',
  mail_contact_type_phone: '手機號碼',
  mail_contact_type_email: '電子信箱',
  mail_contact_type_line: 'LINE ID',
  mail_contact_type_wechat: 'WeChat ID',
  mail_contact_type_detail: '請填寫聯絡方式',
  mail_contact_type_detail_warning: '請填寫您的聯絡方式',
  mail_submit_error: '失敗',
  mail_submit_error_content: '信件傳送失敗，請確認填寫資訊或稍後再試',
  mail_submit_success: '傳送成功',
  mail_submit_success_content: '信件傳送成功！將會有人員與您聯繫',
  mail_is_new_customer: '首次諮詢微媞時尚診所',
  mail_consult_items: '諮詢項目',
  mail_pores_blackheads: '毛孔粉刺',
  mail_beauty_moisturizing: '美容保溼',
  mail_dark_sunspots: '曬斑暗沈',
  mail_fine_lines: '細紋皺紋',
  mail_face_sunken: '臉部凹陷',
  mail_face_lifting: '臉部拉提',
  mail_miracle_thread: '線雕隆鼻',
  mail_laser_hair_removal: '雷射除毛',
  mail_double_eyelid_surgery: '割雙眼皮',
  mail_fat_loss: '消脂塑身',
  mail_other: '其他',
  mail_consult_note: '諮詢項目備註',
  mail_consult_items_warning: '請選擇諮詢項目',
  mail_consult_note_warning: '請敘述諮詢項目',
  mail_agreement_adult: '我已年滿 18 歲。依法規，未滿18歲無法進行療程。',
  mail_agreement_adult_warning: '請確認年滿18歲，才可預約諮詢療程',
  //faq
  faq_question_1: '請問想安排諮詢看診或進行療程需要先預約嗎？',
  faq_answer_1: '為避免現場久候，建議可提前預約，以維護良好服務品質。',
  faq_question_2: '請問諮詢看診需要掛號或收取掛號費嗎？',
  faq_answer_2: '不需要，請透過官方客服或來電門市完成預約即可。',
  faq_question_3: '若諮詢完，想要直接進行療程可以嗎？',
  faq_answer_3:
    '除手術需另外安排治療時間外，其餘雷射，美容，微整等項目基本上當天諮詢完即可施作，但仍需視當日預約狀況而定，若該時段預約已滿，會盡快為您安排其他治療時間。',
  faq_question_4: '我是男生，也可以進行醫美治療嗎？',
  faq_answer_4:
    '當然可以，不管是膚質、五官、除毛保養都是不分男女的，歡迎男士們一起加入愛美的行列。',
  faq_question_5: '懷孕期間，能否進行醫美治療？',
  faq_answer_5:
    '懷孕期間不建議進行任何治療，避免影響宮縮或胎兒發展，建議可以等待產後哺乳結束，再進行諮詢。',
  faq_question_6: '哺乳或坐月子期間，能否進行醫美治療？',
  faq_answer_6:
    '哺乳或坐月子期間可以接受非侵入性的醫美療程，其他治療項目建議可與專業醫師溝通評估後確定是否能夠進行。',
  faq_question_7: '未滿18歲，能否進行醫美治療嗎？',
  faq_answer_7:
    '衛福部規定，未滿18歲者不得接受手術類、微整形及雷射光療類等侵入性醫學美容療程。',
  faq_question_8: '18以上歲未滿20歲者，能否進行醫美治療？',
  faq_answer_8:
    '衛福部規定，18至20歲者若須接受醫學美容等相關療程，須由法定代理人陪同及簽署同意書，並出示法定代理人之身分證核對。',
  footer_statement_text:
    ' 發佈內容已由當事人同意作為醫療資訊分享使用，治療效果因人而異，實際狀況須由專業醫師審慎評估後而定。本站禁止任何網際網路服務業者轉錄其網路資訊之內容供人點閱。但以網路搜尋或超連結方式，進入醫療機構之網址(域)直接點閱者，不在此限。版權所有 © 微媞時尚診所《未經授權同意 請勿節錄或轉載本站圖文》',
  footer_contract_name: '定型化契約',
  terms_title: '微媞時尚診所 隱私權條款/免責聲明/個資使用說明',
  terms_kickoff:
    '歡迎您光臨「微媞時尚診所官方網站」(以下簡稱本網站)。本網站重視每一個使用者所享有的服務與權利，請您細讀本使用條款的內容及使用政策，以保障您的權益。',
  terms_topic_1: '免責聲明',
  terms_topic_1_content:
    '一、本網站有權於任何時間修改或變更內容，建議您隨時注意該等修改或變更。您於任何修改或變更後繼續使用本網站，視為您已閱讀、瞭解並同意接受該等修改或變更。\n\n二、本網站就使用或連結本網頁而生之任何損害（包括但不限於電腦病毒、系統固障、資料損失）、誹謗、侵犯版權或知識財產權所造成的損失，包括但不限於利潤、商譽、使用、資料損失或其他無形損失等，不負任何直接、間接、附帶、特別、衍生性或懲罰性賠償。\n\n三、有關本公司醫療項目皆需經由現場專科執照人員，與貴賓當面依實際情況評估給予建議，同時說明其風險後向使用者本人確認及取得同意後方得已施行，本網站不保證所有服務項目之療效。\n\n四、本網站可能會連接至其他機構所提供的網頁，但不會對這些網頁內容作出任何保證或承擔任何責任。如貴賓決定瀏覽這些網頁，亦或於本網站之服務中自行擷取、下載資料，請您考慮其風險，將自行承擔後果。因前述自行下載資料而導致使用者電腦系統之任何損壞或資料流失，本公司不承擔任何責任。\n\n五、本公司所取得授權曝光之肖像權、圖文授權、影音授權等，經查證非經由本公司書面同意下第三方將其任意轉載、修改使用，此侵權行為及造成所有之損害，本公司不負任何賠償責任，同時視情節將依法通知並提出告訴。\n\n六、本網站維護力求網站內容之準確性及完整性，如若內容有錯誤或遺漏，本網站不會承擔任何賠償責任，本網站所有內容將會隨時更新、或停止網頁資料，及有關條款修正而毋須事前通知使用者。\n\n七、本免責聲明如有未盡事宜，應依中華民國衛生福利部或其他主管機關所制頒資訊使用管理辦法及中華民國法令之規定辦理。',
  terms_topic_2: '隱私權政策',
  terms_topic_2_content:
    '一、本公司遵守個人資料保護法之法令，但若因天災、事變或其他不可抗力所致者，以致您的個人資料被竊取、洩漏、竄改、遭其他侵害者，本公司將於查明後以電話、信函、電子郵件或網站公告等方法，將以適當方式通知貴賓您並保障您的權益。\n\n二、為保護貴賓個人隱私，本公司無法為非本人查詢及提供其他貴賓的相關資料，請您見諒。若您有相關法律上問題需查閱他人資料時，請務必向國家行政機關辦理相關業務，本公司將依法配合有關單位協助調查。\n\n三、由於本網站無法知悉所蒐集到的個人資料是否屬未成年人所有，或是有無得到其法定代理人的同意。如果您對本網站可能有未經法定代理人同意或未有其他法律依據而蒐集未成年人個人資料之疑慮，請您以本聲明所載之聯絡資訊聯繫本行，我們將立刻採取妥善措施進行調查及改正。\n\n四、提醒貴賓應妥善保護個人資料。若您與他人共用電腦或使用公共硬體載具上瀏覽，請務必登出帳號及關閉流覽器視窗，以防止他人讀取您的信件或任何個人相關資料。\n\n五、因應法令修正或時事之事由，本網站有權於任何時間修改或變更本政策之內容，貴賓應經常查看以瞭解您當前的權利及義務。若您於本網站為任何修改、或變更本政策後仍繼續使用本服務，將視為您已同意接受本政策之修改及變更。',
  terms_topic_3: '個資使用聲明',
  terms_topic_3_content: `一、	當您於本網站填寫個人資料，包括姓名、性別、聯絡方式（電話、E-Mail/LINE/ Wechat/諮詢內容）等相關基本資料，微媞時尚診所得依據中華民國「個人資料保護法」與相關法令之規範，蒐集、處理及利用您的個人資料。\n\n二、	微媞時尚診所不會將您的個人資料為特定目的外之使用或是對外公開，在不涉及揭露您的個人身份的統計資料的前提下，您同意本網站為任何合法的使用。而當您的個人資料應用於符合《個人資料保護法》規定之例外情形時，本網站會檢視其適當性與合法性。\n\n三、	本網站蒐集、處理、利用及保有個人資料之特定目的如下：微媞時尚診所將以您提供之資訊進行調查、分析用以管理您的使用者資料、客制化廣告及您看到的網頁內容、了解或改善您對服務的要求、客戶聯繫、進行研究，以及提供內部及外部客戶不記名之市場分析或統計報告，提供微媞時尚診所及相關單位進行行銷、問卷活動。\n\n四、	您的個人資料將於前開蒐集之特定目的存續期間及依法令規定要求之期間內為本網站及微媞時尚診所所利用，且將於中華民國領域內及其他符合主管機關國際傳輸規定之其他地區利用。利用之對象為微媞時尚診所之關係企業、受微媞時尚診所委託處理事務之委外機構或單位、微媞時尚診所之協力廠商、與微媞時尚診所共同行銷或合作推廣業務或交互運用客戶資料之公司、您所同意之對象，及其他依法令規定利用之機構。微媞時尚診所將僅於前述特定目的範圍內，以符合個人資料保護法及相關法令之以自動化機器或其他非自動化之利用方式處理、利用您的個人資料。\n\n五、	當您瀏覽或使用本公司網站提供之服務時，網站將留存由伺服器自行產生的相關紀錄，這些紀錄包括您瀏覽時間、項目、點選紀錄、使用連線設備的IP 位址、讀取時間、使用的瀏覽器等各項資訊。得以全球地區將資料用作以下用途：客制化廣告及您看到的網頁內容、了解或改善您對服務的要求、客戶聯繫、進行研究，以及提供內部及外部客戶不記名之市場分析或統計報告。如果您不希望本網站或關係企業利用這些資料，或與您進一步聯絡，請您事先告知，本公司會尊重您的意願。\n\n六、	本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆有簽屬保密合約，如有違反保密義務者，將會受到相關的法律處分。如因評估需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且執行必要檢查程序以確定其將確實配合遵守。\n\n七、 依據個資法第三條規定，您就本網站所保有之個人資料得行使下列權利：\n  1. 請求本網站刪除、停止搜集、處理或利用。\n  2. 請求本網站補充或更正，惟依法當事人應為之適當說明。\n  於本網站查詢、請求閱覽或請求製給複製本，而本網站依法得酌收必要成本費用。若您欲行使上述之權利時，請與本公司連繫。\n  但因您行使上述權利，而導致相關權益受損時，本公司將不負相關賠償責任。\n\n八、	本網站的網頁亦提供其他網站的網路連結，貴賓也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。\n\n九、 為了提供貴賓更優良的網站體驗，本網站會使用Cookie 技術，若您不希望使用Cookie，您可在所使用的瀏覽器功能項中設定隱私權等級為最高、或自行設定關閉即可。溫馨提醒您，關閉可能會導致網站部分功能無法正常執行。\n\n十、 本網站絕不提供、交換、出租或出售，任何貴賓的個人資料給與其他個人、團體、私人企業或公務機關，但有合約義務者、司法機關或其他政府機關的要求、命令或依法令之規定而須提供者，不在此限。\n\n十一、 提醒貴賓應妥善保護個人資料。若您與他人共用電腦或使用公共硬體載具上瀏覽，請務必登出帳號及關閉流覽器視窗，以防止他人讀取您的信件或任何個人相關資料。\n\n十二、 因應法令修正或時事之事由，本網站有權於任何時間修改或變更本聲明之內容，貴賓應經常查看以瞭解您當前的權利及義務。若您於本網站為任何修改、或變更本政策後仍繼續使用本服務，將視為您已同意接受本政策。`,
};

export {labels};
